import { z } from 'zod'

export function usePassword() {
  const { t } = useI18n()
  const {
    public: { password },
  } = useRuntimeConfig()

  const zodPasswordRule = () => {
    const passwordRegexLookups = [
      password.requireNumber ? '(?=.*\\d)' : undefined,
      password.requireSpecialChar ? '(?=.*[!@#$%^&*])' : undefined,
      password.requireUppercase ? '(?=.*[A-Z])' : undefined,
    ].filter(Boolean)

    const passwordMessages = [
      password.requireNumber
        ? t('validation.password.requireNumber')
        : undefined,
      password.requireSpecialChar
        ? t('validation.password.requireSpecialChar')
        : undefined,
      password.requireUppercase
        ? t('validation.password.requireUppercase')
        : undefined,
    ].filter(Boolean)

    return z
      .string()
      .max(100)
      .min(password.minLength, {
        message: t('validation.password.minLength', {
          min: password.minLength,
        }),
      })
      .regex(new RegExp(`^${passwordRegexLookups.join('')}.*$`), {
        message: t('validation.password.require').concat(
          ' ',
          passwordMessages.join(', '),
        ),
      })
  }

  return {
    zodPasswordRule,
  }
}
